import { fetchData, apiURL } from './api_helper';

const loginUser = credentials => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/login`;
  fetchData(endpointURL, 'post', credentials).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchLoggedInProfile = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/me`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchUsers = (all) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/?all=${all}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchUser = userId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/${userId}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const inviteUsers = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}invitations/`;
  fetchData(endpointURL, 'post', { emails: payload }).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const signUpForBeta = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}signups/`;
  fetchData(endpointURL, 'post', { email: payload }).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchInvitation = code => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}invitations/${code}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchOpenInvitations = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}invitations/?status=0`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const registrate = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/`;
  fetchData(endpointURL, 'post', payload).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const registrateViaInvitation = (invitationCode, payload) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}invitations/${invitationCode}/`;
  fetchData(endpointURL, 'post', payload).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const generatePasswordReset = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/generatePasswordReset`;
  fetchData(endpointURL, 'post', { email }).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const resetPassword = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/resetPassword`;
  fetchData(endpointURL, 'post', data).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const fetchTransactionsForUser = (userId, page) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/${userId}/transactions?page=${page}`;
  fetchData(endpointURL, 'get').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const updateUserProfile = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/me`;
  fetchData(endpointURL, 'post', data).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const configurateCompany = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}companies/configurate`;
  fetchData(endpointURL, 'post', data).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const uploadProfileImage = data => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/me/uploadImage`;
  fetchData(endpointURL, 'post', data, 'multipart/form-data').then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const toggleUserStatus = userId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/${userId}/status`;
  fetchData(endpointURL, 'post', {}).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const changeRole = userId => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/${userId}/changeRole`;
  fetchData(endpointURL, 'post', {}).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const instantRegistration = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}users/instant`;
  fetchData(endpointURL, 'post', { email }).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));


export default {
  loginUser,
  fetchLoggedInProfile,
  fetchUsers,
  inviteUsers,
  signUpForBeta,
  fetchInvitation,
  registrate,
  registrateViaInvitation,
  generatePasswordReset,
  resetPassword,
  fetchUser,
  fetchTransactionsForUser,
  updateUserProfile,
  configurateCompany,
  fetchOpenInvitations,
  uploadProfileImage,
  toggleUserStatus,
  changeRole,
  instantRegistration,
};
